import React from "react";
import { useIntl } from "react-intl";

import useAuthorization from "@hooks/useAuthorization";

import { AdminPermissions } from "@src/enum/Permissions";

export const useReportStateMessageComponent = ({
  isReportCreated,
  processType,
  sourceDataStatus,
}) => {
  const { hasAllPermissions } = useAuthorization();
  const { messages } = useIntl();

  const hasWriteReportAnalysisPermission = hasAllPermissions([
    AdminPermissions.AdminWriteReportAnalysis,
  ]);

  const textToPresent = React.useMemo(() => {
    const notReadyText =
      messages[`text_case_report_${processType}_${sourceDataStatus}`];
    const valueToPresent = String(
      isReportCreated ? messages.text_case_report_created : notReadyText
    );

    return valueToPresent;
  }, [isReportCreated, messages, processType, sourceDataStatus]);

  return {
    hasWriteReportAnalysisPermission,
    textToPresent,
  };
};
